(function() {
  define('bazemont/booking/list',['angular', 'angularAnimate', 'angularBootstrap'], function() {
    'use strict';
    return angular.module('bazemontBookingList', ['ngAnimate', 'ui.bootstrap']).component('bazemontBookingList', {
      templateUrl: '/assets/javascripts/bazemont/booking/list.html',
      controller: [
        '$http', '$uibModal', 'TlhFormService', function($http, $uibModal, TlhFormService) {
          var vm;
          vm = this;
          vm.$onInit = function() {
            vm.initOrderBy = ['-bookingDate', 'item.shortName'];
            vm.orderBy = vm.initOrderBy;
            return $http.get('/api/admin/booking/list').then(function(response) {
              vm.bookingItems = response.data.bookingItems;
              vm.bookingStatuses = response.data.bookingStatuses;
              return vm.bookingRequests = response.data.bookingRequests;
            });
          };
          vm.showBookingRequest = function(bookingRequest) {
            return TlhFormService.isCheckedOrNothing(bookingRequest.item.id, vm.bookingItems) && TlhFormService.isCheckedOrNothing(bookingRequest.status.id, vm.bookingStatuses);
          };
          vm["export"] = function($event) {
            var checkedBookingItems, checkedBookingStatuses;
            $event.stopPropagation();
            $event.preventDefault();
            checkedBookingItems = vm.bookingItems.filter(function(item) {
              return item.checked;
            }).map(function(item) {
              return item.id;
            });
            checkedBookingStatuses = vm.bookingStatuses.filter(function(status) {
              return status.checked;
            }).map(function(status) {
              return status.id;
            });
            window.open('/admin/reservations/export/reservations.csv?items=' + checkedBookingItems + '&statuses=' + checkedBookingStatuses + '&order=' + vm.orderBy, '_blank', '');
          };
          vm.openModal = function(bookingRequest) {
            var modal;
            return modal = $uibModal.open({
              templateUrl: '/assets/javascripts/bazemont/booking/modal.html',
              controllerAs: '$ctrl',
              bindToController: true,
              resolve: {
                data: {
                  bookingRequest: bookingRequest
                }
              },
              controller: [
                '$uibModalInstance', '$http', '$window', 'data', 'TlhNotificationService', function($uibModalInstance, $http, $window, data, TlhNotificationService) {
                  var mvm, sendRequest;
                  mvm = this;
                  mvm.bookingRequest = data.bookingRequest;
                  mvm.isAdmin = true;
                  modal.backdrop = 'static';
                  mvm.getFullAddress = function() {
                    return mvm.bookingRequest.address + (mvm.bookingRequest.isLocal ? ', 78580, Bazemont' : ', ' + mvm.bookingRequest.zipCode + ', ' + mvm.bookingRequest.city);
                  };
                  mvm.acceptRequest = function() {
                    return sendRequest('/api/admin/booking/accept/' + mvm.bookingRequest.id);
                  };
                  mvm.rejectRequest = function() {
                    return sendRequest('/api/admin/booking/reject/' + mvm.bookingRequest.id);
                  };
                  sendRequest = function(url) {
                    if (!mvm.submitting) {
                      mvm.submitting = true;
                      TlhNotificationService.info({
                        message: 'Enregistrement en cours...',
                        delay: false
                      });
                      return $http.get(url).then(function(response) {
                        TlhNotificationService.success({
                          message: 'Enregistrement terminé',
                          replaceMessage: true
                        });
                        mvm.bookingRequest.status = response.data.status;
                        return $uibModalInstance.close();
                      })["catch"](function(error) {
                        var message;
                        console.error(error);
                        message = "Erreur inattendue, veuillez contacter l'administrateur.";
                        return TlhNotificationService.error({
                          message: message,
                          replaceMessage: true,
                          delay: false
                        });
                      })["finally"](function() {
                        return mvm.submitting = false;
                      });
                    }
                  };
                  mvm.redirectToForm = function() {
                    if (!mvm.submitting) {
                      return $window.location.href = '/admin/reservations/' + mvm.bookingRequest.id;
                    }
                  };
                  mvm.close = function() {
                    return $uibModalInstance.dismiss();
                  };
                }
              ]
            });
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=list.js.map
;
